import FormsManager from '@/manager/2.6/FormsManager';
import { IDataPointsAddFields } from '@/models/AdditionalFields';
import IFormFields from '@/models/forms/IFormFields';

export default {
    /**
     * Get form fields from the store for the form code found in local storage.
     * When none are found in the store, will fetch from the service and place into the store.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @returns the form fields array, empty on an error or unsupported form code
     */
    async getFormFields(): Promise<IFormFields> {
        const formFields = await FormsManager.getFormFields();
        return formFields;
    },

    /**
     * Fetches form fields through the FormsManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param formCode
     * @returns the form fields array, empty on an error or unsupported form code
     */
    async fetchAndStoreFormFields(formCode: string): Promise<IFormFields> {
        const formFields = await FormsManager.fetchAndStoreFormFields(formCode);
        return formFields;
    },
};
